import { z } from 'zod';

import type { InteractiveTokensCompatibilityResponse } from './interactive-token-compatibility.dto.js';
import { UserAuthTokensResponseSchema } from './session.schema.js';

// Preserve the published six-field shape exactly. Partial modern metadata must fail.
const LegacyInteractiveTokensResponseSchema = UserAuthTokensResponseSchema.pick({
  accessToken: true,
  refreshToken: true,
  expiresInMs: true,
  sessionType: true,
  companyId: true,
  authzVersion: true,
}).strict();

// Opt-in response reader, used only by Web. Canonical issuer/claims schemas remain strict.
export const InteractiveTokensCompatibilityResponseSchema: z.ZodType<InteractiveTokensCompatibilityResponse> =
  z.union([UserAuthTokensResponseSchema, LegacyInteractiveTokensResponseSchema])
    .refine(
      (value) => value.sessionType === 'identity'
        ? value.companyId === null
        : value.companyId !== null,
      { message: 'Token response scope is inconsistent' },
    )
    .refine(
      (value) => !('principalId' in value) || value.principalId === value.userId,
      { message: 'Interactive principal must match user identity' },
    );

export const IdentityTokensCompatibilityResponseSchema =
  InteractiveTokensCompatibilityResponseSchema.refine(
    (value) => value.sessionType === 'identity',
    { message: 'Expected an identity session' },
  );
